import { useEffect, useRef } from "react";
import { TopBar, CoachRibbon } from "../kit";
import { useChromelessOverride } from "../../context/ChromelessOverrideContext";
import { COACH_HOME } from "../../lib/homePath";
import { AccessibilityMenu } from "../AccessibilityMenu";
import { AccountMenu } from "../AccountMenu";
import { NotificationsBell } from "../NotificationsBell";

/**
 * Issue #1316 (Pick XI coach 1 of 3; D297, D250) — the coach chrome the three
 * Pick XI screens share: the white `TopBar` and the coach ribbon with Your
 * players current, copied from `LearnChrome`. The board draws no top-bar
 * caption (D250). The page's hidden `h1` takes focus once on mount, as
 * `LearnChrome` does, so a keyboard user is not dropped on BODY after a tap.
 *
 * The three screens are coach-only (their routes say so in `App.js`), so this
 * does not read the account's role.
 */
export default function PickXiChrome({ title, testId = "pickxi-page", children }) {
  const { setActive: setChromeless } = useChromelessOverride();
  const headingRef = useRef(null);

  useEffect(() => {
    setChromeless(true);
    return () => setChromeless(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (title && headingRef.current) headingRef.current.focus({ preventScroll: true });
  }, [title]);

  return (
    <div data-testid={testId} style={{ color: "var(--nw-ink)" }}>
      <TopBar
        variant="white"
        homeHref={COACH_HOME}
        homeLabel="CricketCompass — go to your players"
        endControls={
          <>
            <NotificationsBell compact surface="white" />
            <AccessibilityMenu compact surface="white" />
            <AccountMenu empty surface="white" hasRibbon />
          </>
        }
        data-testid="pickxi-topbar"
      />
      <CoachRibbon current="players" />
      {title && (
        <h1 ref={headingRef} tabIndex={-1} className="sr-only" data-testid="pickxi-heading">
          {title}
        </h1>
      )}
      {children}
    </div>
  );
}
